import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/authContext/authContext";

export const PublicRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user.name && (user.rol === "Admin" || user.rol === "Monitorista") ? (
    <Navigate to="/programar-salida" />
  ) : user.name && user.rol === "Administrador de cedis" ? (
    <Navigate to="/programar-ruta" />
  ) : user.name && user.rol === "S.W.A.T" ? (
    <Navigate to="/tablero" />
  ) : (
    children
  );
};
